export default function getSafeCommentContent(possiblyUnsafeContent: string) {
  return possiblyUnsafeContent.replace(/(\n{2,})/g, "\n\n");
}
